/**
 * toast.js — thông báo nhỏ góc phải dưới, tự ẩn sau 4 giây (mục 13).
 *
 * API: WBToast.show('Đã thêm vào giỏ hàng', { action: { label: 'Xem giỏ', href: 'cart.html' } })
 * Vùng chứa [data-toast-region] có aria-live="polite" nên trình đọc màn hình đọc nội
 * dung mà không cướp focus. Rê chuột / focus vào toast thì tạm dừng đếm giờ để kịp bấm
 * nút hành động. Tối đa 3 toast cùng lúc, cái cũ nhất bị đẩy ra.
 *
 * Viết theo cú pháp ES5 vì pipeline dùng uglify-js sau babel.
 */
(function () {
    'use strict';

    var DURATION = 4000;
    var MAX = 3;

    function region() {
        var el = document.querySelector('[data-toast-region]');
        if (!el) {
            el = document.createElement('div');
            el.className = 'toast-region';
            el.setAttribute('aria-live', 'polite');
            el.setAttribute('data-toast-region', '');
            document.body.appendChild(el);
        }
        return el;
    }

    function dismiss(toast) {
        if (!toast || toast.classList.contains('is-leaving')) return;
        window.clearTimeout(toast._timer);
        toast.classList.add('is-leaving');
        window.setTimeout(function () {
            if (toast.parentNode) toast.parentNode.removeChild(toast);
        }, 220);
    }

    function show(message, options) {
        options = options || {};
        var box = region();

        var toast = document.createElement('div');
        toast.className = 'toast';
        toast.setAttribute('role', 'status');

        if (options.icon) {
            var icon = document.createElement('i');
            icon.className = options.icon;
            icon.setAttribute('aria-hidden', 'true');
            toast.appendChild(icon);
        }

        var text = document.createElement('span');
        text.className = 'toast__text';
        text.textContent = message;
        toast.appendChild(text);

        if (options.action) {
            var action = document.createElement('a');
            action.className = 'toast__action';
            action.href = options.action.href || '#';
            action.textContent = options.action.label;
            toast.appendChild(action);
        }

        box.appendChild(toast);
        // Chỉ đếm toast còn hiện: dismiss() gỡ phần tử sau 220ms, nên đếm box.children thì toast "đang rời" vẫn
        // tính và vòng lặp không bao giờ dừng (treo tab khi bắn > MAX toast trong 220ms — bấm thêm giỏ liên tục)
        var live = [].slice.call(box.children).filter(function (el) {
            return !el.classList.contains('is-leaving');
        });
        while (live.length > MAX) dismiss(live.shift());

        function arm() {
            window.clearTimeout(toast._timer);
            toast._timer = window.setTimeout(function () {
                dismiss(toast);
            }, DURATION);
        }

        toast.addEventListener('mouseenter', function () {
            window.clearTimeout(toast._timer);
        });
        toast.addEventListener('mouseleave', arm);
        toast.addEventListener('focusin', function () {
            window.clearTimeout(toast._timer);
        });
        toast.addEventListener('focusout', arm);
        arm();

        return toast;
    }

    window.WBToast = { show: show, dismiss: dismiss };
})();
